import { createSelector } from 'reselect'

/**
 * Select the auth state slice
 * @param {object} state - Redux state
 * @returns {object} Auth state
 */
export const selectAuth = (state) => state.auth

/**
 * Select the account configuration
 * @param {object} state - Redux state
 * @returns {object} Account config
 */
export const selectAccountConfig = createSelector(
  selectAuth,
  (auth) => auth.accountConfig
)

/**
 * Select the user configuration
 * @param {object} state - Redux state
 * @returns {object} User config
 */
export const selectUserConfig = createSelector(
  selectAuth,
  (auth) => auth.userConfig
)

/**
 * Select the account ID
 * @param {object} state - Redux state
 * @returns {string} Account ID
 */
export const selectAccountId = createSelector(
  selectAuth,
  (auth) => auth.accountId
)

/**
 * Select the account hash
 * @param {object} state - Redux state
 * @returns {string} Account hash
 */
export const selectAccountHash = createSelector(
  selectAuth,
  (auth) => auth.accountHash
)

/**
 * Select the API key
 * @param {object} state - Redux state
 * @returns {string} API key
 */
export const selectApiKey = createSelector(
  selectAuth,
  (auth) => auth.apiKey
)

/**
 * Select the auth hash
 * @param {object} state - Redux state
 * @returns {string} Auth hash
 */
export const selectHash = createSelector(
  selectAuth,
  (auth) => auth.hash
)

/**
 * Select whether the user is authenticated
 * @param {object} state - Redux state
 * @returns {boolean} Authentication status
 */
export const selectIsAuthenticated = createSelector(
  selectAuth,
  (auth) => auth.isAuthenticated
)
